import React from 'react';
import styles from './About.module.css';

function About() {
  return (
    <section className={styles.about}>
      <h2>About Us</h2>
      <p>
        Destiny Kids Nursery and Primary School is a private day school for boys and girls. Since opening in 2016, we have grown to a vibrant community of 620 learners. Our school was founded to be a centre of excellence, caring for everyone and empowering each student to ambition and responsibility.<br/>
        Our motto, <strong>"Knowledge is Wealth"</strong>, inspires our pupils to transform themselves and others.
      </p>
    </section>
  );
}

export default About;
